import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import "@/App.css";

const Home = () => (
  <div className="min-h-screen bg-[#F7F6F2] text-[#1A1A1A] antialiased selection:bg-[#8B1A1A] selection:text-white">
    <Nav />
    <main>
      <Hero />
      <Services />
      <About />
      <Contact />
    </main>
    <Footer />
    <WhatsAppFloat />
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#1A1A1A",
          color: "#F7F6F2",
          border: "1px solid #8B1A1A",
          borderRadius: 0,
        },
      }}
    />
  </div>
);

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
